import {  Card, List } from "antd";
import React from "react";
import { FcDatabase, FcList, FcMoneyTransfer } from "react-icons/fc";
import { useSelector } from "react-redux";

const CashbookSummary = () => {
    const { dashboardData: data } = useSelector(
        (state) => state.dashboardState
      );
  const list = [
    {
      name: 'TOTAL AMOUNT RECEIVED',   
      description: 'Total amount received in the cashbook',
      content: `UGX ${data.cashbook?.totalAmountReceived?.toLocaleString() || 0}`,
      icon: <FcMoneyTransfer />
    },
    {
        name: 'TOTAL EXPENDITURE',
        description: 'Total expenditure recorded in the cashbook',
        content: `UGX ${data.cashbook?.totalExpenditure?.toLocaleString() || 0}`,
        icon: <FcList />
    }, 
    {
        name: 'CASHBOOK BALANCE',
        description: 'Current cashbook balance',
        content: `UGX ${data.cashbook?.availableBalance?.toLocaleString() || 0}`,
        icon: <FcDatabase />
    }
  ];

  return (
    <Card title="CASHBOOK SUMMARY" className="mb-2">
      <List
        itemLayout="horizontal"
        dataSource={list}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta
                avatar={item.icon}
                title={<a href="https://ant.design">{item.name}</a>}
                description={item.description}
              />
              <div>
                <p className="text-primary">{item.content}</p>
              </div>
          </List.Item>
        )}
      />
    </Card>
  );
};

export default CashbookSummary;
